import Vue from 'vue';
import VueRouter from 'vue-router';
import Dashboard from '@/views/Dashboard.vue';
import authService, { AuthRole } from '@/services/authService';
import { take } from "rxjs/operators";
Vue.use(VueRouter);
export const defaultRoutes = new Map([
    [AuthRole.staff, 'dashboard'],
    [AuthRole.other, 'invalid-role'],
    [AuthRole.anonymous, 'login'],
]);
const routes = [
    {
        name: 'dashboard',
        path: '/',
        meta: { role: AuthRole.staff },
        component: Dashboard
    },
    {
        name: 'users',
        path: '/users',
        meta: { role: AuthRole.staff },
        component: () => import(/* webpackChunkName: "users" */ '../views/Users.vue')
    },
    {
        name: 'invite_user',
        path: '/users/invite',
        meta: { role: AuthRole.staff },
        component: () => import(/* webpackChunkName: "invite_user" */ '../views/InviteUser.vue')
    },
    {
        name: 'edit_user',
        path: '/users/edit/:id',
        props: true,
        meta: { role: AuthRole.staff },
        component: () => import(/* webpackChunkName: "edit_user" */ '../views/EditUser.vue')
    },
    {
        name: 'programming',
        path: '/programming',
        props: true,
        meta: { role: AuthRole.staff },
        component: () => import(/* webpackChunkName: "programming" */ '../views/Programming.vue')
    },
    {
        name: 'history-list',
        path: '/programming/history',
        props: true,
        meta: { role: AuthRole.staff },
        component: () => import(/* webpackChunkName: "programming" */ '../views/HistoryList.vue')
    },
    {
        name: 'history-view',
        path: '/programming/history/:year/:week/:day',
        props: true,
        meta: { role: AuthRole.staff },
        component: () => import(/* webpackChunkName: "programming" */ '../views/HistoryView.vue')
    },
    {
        name: 'schedule',
        path: '/schedule',
        props: true,
        meta: { role: AuthRole.staff },
        component: () => import(/* webpackChunkName: "schedule" */ '../views/Schedule.vue')
    },
    {
        name: 'videos_list',
        path: '/videos',
        meta: { role: AuthRole.staff },
        component: () => import(/* webpackChunkName: "users" */ '../views/VideosList.vue')
    },
    {
        name: 'video_add',
        path: '/videos/add',
        meta: { role: AuthRole.staff },
        component: () => import(/* webpackChunkName: "invite_user" */ '../views/VideoAdd.vue')
    },
    {
        name: 'video_edit',
        path: '/videos/edit/:id',
        props: true,
        meta: { role: AuthRole.staff },
        component: () => import(/* webpackChunkName: "edit_user" */ '../views/VideoEdit.vue')
    },
    {
        name: 'competitions_list',
        path: '/competitions',
        meta: { role: AuthRole.staff },
        component: () => import(/* webpackChunkName: "users" */ '../views/CompetitionsList.vue')
    },
    {
        name: 'competition_add',
        path: '/competitions/add',
        meta: { role: AuthRole.staff },
        component: () => import(/* webpackChunkName: "invite_user" */ '../views/CompetitionAdd.vue')
    },
    {
        name: 'competition_edit',
        path: '/competitions/edit/:id',
        props: true,
        meta: { role: AuthRole.staff },
        component: () => import(/* webpackChunkName: "edit_user" */ '../views/CompetitionEdit.vue')
    },
    {
        name: 'login',
        path: '/login',
        meta: { role: AuthRole.anonymous },
        component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
    },
    {
        name: 'forgot-password',
        path: '/forgot-password',
        meta: { role: AuthRole.anonymous },
        component: () => import(/* webpackChunkName: "forgot-password" */ '../views/ForgotPassword.vue')
    },
    {
        name: 'reset-password',
        path: '/reset-password',
        meta: { role: AuthRole.anonymous },
        component: () => import(/* webpackChunkName: "reset-password" */ '../views/ResetPassword.vue')
    },
    {
        name: 'invalid-role',
        path: '/invalid-role',
        meta: { role: AuthRole.other },
        component: () => import(/* webpackChunkName: "invalid-role" */ '../views/InvalidRole.vue')
    },
    ...process.env.VUE_APP_REMOTE_ENV === 'development' ? [
        {
            name: 'register',
            path: '/register',
            meta: { role: AuthRole.anonymous },
            component: () => import(/* webpackChunkName: "register" */ '../views/Register.vue')
        },
    ] : []
];
const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});
router.beforeEach(async (to, from, next) => {
    const session = await authService.session.pipe(take(1)).toPromise();
    const redirect = to.matched.some(it => it.meta.role === session.role) ? null : defaultRoutes.get(session.role);
    if (redirect != null) {
        next({ name: redirect });
    }
    else {
        next();
    }
});
export default router;
